import { ArticleData } from "articlePage/stateInterfaces"
import { MediaContentTypes } from "constants/contentTypes"
import { HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink"
import { RenderReactAtSite } from "widgets/commonComponents/inline/renderReactAtSite"
import { SiteSimpleImage } from "widgets/commonComponents/inline/siteSimpleImage"
import { SlotIconDisplay } from "widgets/commonComponents/inline/slotIconDisplay/slotIconDisplay"
import { ComponentaIconType, IFieldDisplayData, LinkedItemType, VideoSettingsData } from "widgets/commonDataObjects/interfaces"
import { PageComponentaContext, SiteImageData, SiteItemData, SiteMediaData } from "widgets/interfaces"
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay"
import { MutamMarketingSign } from "../../../../commonComponents/inline/marketingSign/mutamMarketingSign"
import { SiteMediaMobileWrapper } from "../../../../siteWidgets/siteMediaMutamWrapper"

interface MultiImagesFrontProps {
    imageWidth: number
    imageHeight: number
    item?: SiteItemData
    videoSettings?: VideoSettingsData
    fieldsDisplaySettings?: IFieldDisplayData
    titleColor: string
    getArticle(articleId: string): ArticleData
    displayType: string
    index: number
    isImageOnly: boolean
    isMutamView?: boolean
}

export class MultiImagesItemFrontMobile extends React.Component<MultiImagesFrontProps & Partial<PageComponentaContext>>{
    private getIcon = (icon: ComponentaIconType, displayVideoIcon: boolean) => {
        if (icon === "automatic" && displayVideoIcon) return "video"
        return icon;
    }
    public render() {
        const { imageWidth, item, imageHeight, videoSettings, fieldsDisplaySettings, titleColor, getArticle, displayType, index, isImageOnly } = this.props
        let emptyMedia: SiteMediaData = { url: "", mediaType: MediaContentTypes.MEDIA_IMAGE, title: "", className: "", alt: "", ariaHidden: true } as SiteImageData
        const titleStyle = { color: titleColor }
        const icon = item.icon ? item.icon : "automatic"
        const showUpInfoArea = fieldsDisplaySettings.isChannelNameVisible
        const authorImage = getArticle(item.itemId).firstAuthorImage
        const isSpecialBigItem = displayType === "MultiArticleImages" && index === 0;
        const isSmallItem = !isSpecialBigItem;

        return (
            <div className="slotView">
                <div className="mediaArea" data-tb-thumbnail='' style={{ position: !isSmallItem ? "relative" : "unset" }}>
                    <div className="MediaCarousel">
                        <RenderReactAtSite>
                            <SiteMediaMobileWrapper
                                data={item.media !== undefined ? item.media : emptyMedia}
                                width={imageWidth}
                                height={imageHeight}
                                videoSettings={videoSettings}
                                itemLinkUrl={item.titleLink}
                                isImageLinkable={true}
                                linkTarget={item.titleTargetLink !== undefined && item.titleTargetLink} />
                        </RenderReactAtSite>

                        <SlotIconDisplay itemId={item.itemId} icon={this.getIcon(icon, item.displayVideoIcon)} iconClassName="medium" isIconVisible={item.displayVideoIcon || icon === "video" || icon === "automatic"} />
                        {!item.isMarketingContent && item.redLabelText && item.redLabelText.length > 0 && <span className={`basicLabel labelText ${item.textPlace}`}>{item.redLabelText}</span>}
                    </div>

                    {!isSmallItem && item.isMarketingContent &&
                        <RenderReactAtSite>
                            <MutamMarketingSign isSmallItem={false} marketingContentText={item.marketingContentText} />
                        </RenderReactAtSite>}

                </div>

                {!isImageOnly && <div className="textArea">
                    {showUpInfoArea &&
                        <div className="upInfoArea">
                            {fieldsDisplaySettings.isChannelNameVisible && item.subchannelName !== null && item.subchannelName}
                        </div>}

                    {fieldsDisplaySettings.isTitleVisible &&
                        <div className={`slotTitle medium ${item.isCommertial ? "commertialTitle" : ""}`}>
                            <HyperLinkBuilder
                                href={item.titleLink}
                                linkTarget={item.titleTargetLink !== undefined && item.titleTargetLink}
                                children={item.title}
                                isDataTbLink >
                                <div dangerouslySetInnerHTML={{ __html: item.title }} style={titleStyle} data-tb-title />
                            </HyperLinkBuilder>
                        </div>}
                    {fieldsDisplaySettings.isSubTitleVisible &&
                        <div className="slotSubtitle">
                            <HyperLinkBuilder
                                href={item.titleLink}
                                linkTarget={item.titleTargetLink !== undefined && item.titleTargetLink}
                                children={item.subTitle}
                                isDataTbLink >
                                <div dangerouslySetInnerHTML={{ __html: item.subTitle}} style={titleStyle} data-tb-title />
                            </HyperLinkBuilder>
                        </div>}

                    <div className="moreDetails">
                        {displayType === "MultiArticleImages" && authorImage && <div className="authorImage"><SiteSimpleImage src={authorImage} /></div>}
                        {fieldsDisplaySettings.isAuthorVisible && <span className="authorInfo" data-tb-author>{item.author}</span>}
                        {fieldsDisplaySettings.isAuthorVisible && fieldsDisplaySettings.isDateVisible && item.author.length > 0 && item.itemType === LinkedItemType.ARTICLE && <span className="separator">|</span>}
                        {fieldsDisplaySettings.isDateVisible && item.itemType === LinkedItemType.ARTICLE && <DateDisplay date={item.dateUpdatedOnSite} isTbDate />}
                    </div>
                </div>}
                {isSmallItem && item.isMarketingContent &&
                    <RenderReactAtSite>
                        <MutamMarketingSign isSmallItem={true} marketingContentText={item.marketingContentText} />
                    </RenderReactAtSite>}
            </div>
        )
    }
}